<template>
  <WidgetPanel v-if="success">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Aus dem Logbuch
        </h3>
      </div>
    </template>
    <template #default>
      <div class="divide-y divide-gray-200">
        <div class="block hover:bg-gray-50">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <p class="text-sm font-medium text-gray-600">
                  {{ resource.content }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({podcast: Object});

const target = computed(() => '/api/advices:random');

const action = useRetrieveResource(target);

const { retrieve, retrieving, resource, success } = action;

const mounted = onMounted(() => retrieve());
</script>
